module.exports = __webpack_public_path__ + "media/equip.9167155d.mp3";